import { css } from '@emotion/react';

import { styleguideColors as COLORS } from '@/Client/Styles/kaiShikiTokens';
import { pxToRem } from '@/Client/Styles/pxToRem';
import { styleguideFontFamily as FONT } from '@kaiizen/kai-shiki/core';

export const NEW_VIDEO_BUTTON_STYLE = css`
  label: FOCUS_PANEL_NEW_VIDEO_BUTTON;
  height: 26px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  border: 1px solid ${COLORS.midtone};
  background: transparent;
  color: ${COLORS.ink};
  font-family: ${FONT.display};
  font-size: ${pxToRem(9.5)};
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: ${COLORS.ink};
    background: ${COLORS.sunken};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

/** Active analyze-job loader state — mirrors the hover wash without requiring hover. */
export const NEW_VIDEO_BUTTON_ACTIVE_STYLE = css`
  label: FOCUS_PANEL_NEW_VIDEO_BUTTON_ACTIVE;
  border-color: ${COLORS.ink};
  background: ${COLORS.sunken};
`;
